(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  function init(section) {
    if (!section || section.dataset.premiumInit === '1') return;
    section.dataset.premiumInit = '1';

    const track = section.querySelector('.premium-pdp__main-images');
    const galleryNav = section.querySelector('[data-premium-gallery-nav]');
    if (track && galleryNav) {
      const slides = track.querySelectorAll('.premium-pdp__main-image');
      const total = slides.length;
      if (total > 1) {
        const counterEl = galleryNav.querySelector('[data-gallery-counter]');
        const prevBtn = galleryNav.querySelector('[data-gallery-prev]');
        const nextBtn = galleryNav.querySelector('[data-gallery-next]');

        function slideSpan() {
          return track.clientWidth || 1;
        }

        function getIndex() {
          const w = slideSpan();
          return Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / w)));
        }

        function syncNav() {
          const i = getIndex();
          if (counterEl) counterEl.textContent = (i + 1) + ' / ' + total;
          if (prevBtn) prevBtn.disabled = i <= 0;
          if (nextBtn) nextBtn.disabled = i >= total - 1;
        }

        function goTo(index) {
          const clamped = Math.max(0, Math.min(total - 1, index));
          const x = clamped * slideSpan();
          track.scrollTo({ left: x, behavior: 'smooth' });
        }

        let scrollTicking = false;
        track.addEventListener('scroll', function() {
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(function() {
            scrollTicking = false;
            syncNav();
          });
        }, { passive: true });

        if (prevBtn) prevBtn.addEventListener('click', function() { goTo(getIndex() - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function() { goTo(getIndex() + 1); });

        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(syncNav, 120);
        });

        syncNav();
      }
    }

    let variants = [];
    try {
      const node = section.querySelector('[data-variants-json]');
      if (node) variants = JSON.parse(node.textContent) || [];
    } catch (e) {}

    // Quantity
    section.querySelectorAll('[data-qty-step]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input[name="quantity"]');
        const step = parseInt(btn.dataset.qtyStep, 10);
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Variant change → update id input + labels + price
    const optionInputs = section.querySelectorAll('.premium-pdp__option-input');
    function getCurrentOptions() {
      const selected = [];
      section.querySelectorAll('.premium-pdp__option').forEach(opt => {
        const checked = opt.querySelector('.premium-pdp__option-input:checked');
        if (checked) selected.push(checked.value);
      });
      return selected;
    }
    function findVariant(opts) {
      return variants.find(v => v.options.every((o, i) => o === opts[i])) || null;
    }
    function moneyFormat(cents) {
      const fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style:'currency', currency: fmt, minimumFractionDigits:0 }).format(cents/100);
      } catch (e) {
        return 'Rs. ' + (cents/100).toFixed(2);
      }
    }
    function updateUI(variant) {
      if (!variant) return;
      const idInput = section.querySelector('[data-variant-id-input]');
      if (idInput) idInput.value = variant.id;

      // Update selected labels
      section.querySelectorAll('[data-option-selected]').forEach((el) => {
        const idx = parseInt(el.getAttribute('data-option-selected'), 10);
        if (!Number.isNaN(idx) && variant.options[idx]) el.textContent = variant.options[idx];
      });

      // Update prices
      const priceEls = section.querySelectorAll('.premium-pdp__price');
      const cmpEl = section.querySelector('.premium-pdp__price-compare s');
      const saveEl = section.querySelector('.premium-pdp__save-badge');
      const stickyPrice = section.querySelector('.premium-pdp__sticky-price');

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEls.forEach(el => {
        if (el.classList.contains('premium-pdp__price--sale') || !onSale) el.textContent = moneyFormat(variant.price);
      });
      if (cmpEl) cmpEl.textContent = onSale ? moneyFormat(variant.compare_at_price) : '';
      if (saveEl && onSale) {
        const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        saveEl.textContent = 'SAVE ' + pct + '%';
      }
      if (stickyPrice) {
        stickyPrice.innerHTML = moneyFormat(variant.price) + (onSale ? ' <s>'+moneyFormat(variant.compare_at_price)+'</s>' : '');
      }

      // Availability
      const submitBtn = section.querySelector('[data-add-to-cart]');
      const buyBtn = section.querySelector('[data-buy-now]');
      const stickyBtn = section.querySelector('[data-sticky-add]');
      [submitBtn, buyBtn, stickyBtn].forEach(b => {
        if (!b) return;
        b.disabled = !variant.available;
      });
      if (submitBtn) submitBtn.querySelector('[data-add-label]').textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      // History state
      if (window.history.replaceState && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        const variant = findVariant(getCurrentOptions());
        updateUI(variant);
      });
    });

    // Sticky mobile bar
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const buyButtons = section.querySelector('.premium-pdp__atc-row');
    if (stickyBar && buyButtons && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => stickyBar.classList.toggle('is-visible', !e.isIntersecting));
      }, { rootMargin:'0px 0px -100px 0px' });
      io.observe(buyButtons);
    }
    const stickyAdd = section.querySelector('[data-sticky-add]');
    if (stickyAdd) {
      stickyAdd.addEventListener('click', () => {
        const submit = section.querySelector('[data-add-to-cart]');
        if (submit) submit.click();
      });
    }

    // Pincode checker (basic — uses local list of serviceable prefixes; merchant can wire real API)
    const pinForm = section.querySelector('[data-pincode-checker]');
    if (pinForm) {
      const input = pinForm.querySelector('[data-pincode-input]');
      const btn = pinForm.querySelector('[data-pincode-submit]');
      const result = pinForm.querySelector('[data-pincode-result]');
      const check = () => {
        const v = (input.value || '').trim();
        if (!/^\d{6}$/.test(v)) {
          result.textContent = 'Please enter a valid 6-digit pincode.';
          result.className = 'premium-pdp__pincode-result is-error';
          return;
        }
        // Simple heuristic — merchant should replace with serviceability API call.
        result.textContent = '✓ Delivery available. Estimated 4–7 business days.';
        result.className = 'premium-pdp__pincode-result is-success';
      };
      btn.addEventListener('click', check);
      input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); check(); } });
    }
  }

  document.querySelectorAll('.premium-pdp').forEach(init);
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('.premium-pdp');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
